import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CROSS, SUBSCRIPTION_FRAME } from 'src/defaultImages.js';
import { LocalStorageService } from '../../services/localStorage.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';
import { CollectionInfrastructureHelperService } from 'src/app/collection-infrastructure/collection-infrastructure-helper.service';
import { SystemLockService } from '../../services/system-lock.service';

@Component({
  selector: 'app-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.css'],
})
export class SubscriptionBannerComponent implements OnInit, OnDestroy {
  @Input() restaurantId;
  private intervalId: any;
  images = {
    CLOSE: CROSS,
    SUBSCRIPTION_FRAME: SUBSCRIPTION_FRAME,
  };
  loading: boolean = false;
  dismissBanners: boolean = false;
  showBanner: boolean = true;
  subscriptionDetails: any;
  bannerType: boolean;
  formattedString: SafeHtml;

  constructor(
    private _collectionInfraService: CollectionInfrastructureService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _local: LocalStorageService,
    private _cdr: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,
    private _systemLockService: SystemLockService
  ) {}

  ngOnInit(): void {}

  renew() {
    this._ciHelperService.redirectToSubscriptionPage()
  }

  dismissBanner() {
    this._collectionInfraService
      .dismissBannerSubscription(this.restaurantId)
      .then((isDismissed) => {
        if (isDismissed) {
          this.showBanner = false;
          this.scheduleGetSubscription();
        }
      })
      .catch((error) => {
        console.error(error);
        // Implement error handling here (e.g., show a user-friendly error message)
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.restaurantId && this.restaurantId) {
      this.scheduleGetSubscription();
    }
  }

  async getSubscription() {
    try {
      const response = await this._collectionInfraService.getRestaurantDetails(
        this.restaurantId
      );
      if ((response || {}).statusCode === 200) {
        this.subscriptionDetails =
          ((response || {}).data || {}).currentPlan || {};
        const blockFeatureList = ((response || {}).data || {}).blockFeatureList;
        this._local.set('blockFeatureList', JSON.stringify(blockFeatureList));
        if (Object.keys(this.subscriptionDetails).length) {
          this._local.set('subscription', true);
          this._local.set(
            'planType',
            (this.subscriptionDetails || {}).planType
          );
          this._local.set(
            'isPlanExpired',
            this.subscriptionDetails.expired || false
          );
          this._local.set(
            'bannerType',
            (this.subscriptionDetails || {}).bannerType || ''
          );
          this.formattedString = this.boldKeywords(
            (this.subscriptionDetails || {}).bannerText || ''
          );
          this.showBanner = (this.subscriptionDetails || {}).showBanner;
          this.bannerType = (this.subscriptionDetails || {}).bannerType === 0;
          if ((this.subscriptionDetails || {}).locked) {
            this._systemLockService.setLocked(true);
            this._systemLockService.showLockModal();
          } else {
            this._systemLockService.setLocked(false);
          }
          this._cdr.detectChanges();
        } else {
          this._local.set('subscription', false);
          this._local.remove('bannerType');
          this._local.remove('isPlanExpired');
        }
      }
    } catch (error) {
      console.error('Error fetching subscription details:', error);
    }
  }

  getCurrencySymbol(): string {
    const countryCode = this._local.get('country_code') || 'MY';
    const currencyMap: Record<string, string> = {
      'MY': 'RM',
      'ID': 'Rp',
      'SG': 'S$',
    };
    return currencyMap[countryCode] || 'RM';
  }

  boldKeywords(text: string): SafeHtml {
    // Define the regex pattern
    const pattern = /(today|tomorrow|\d+ days?|\b\d{2}\/\d{2}\/\d{4}\b)/gi;

    // Replace the matching words/phrases with bold HTML tags
    const formattedText = text.replace(pattern, '<b>$&</b>');

    // Sanitize the formatted HTML
    return this._sanitizer.bypassSecurityTrustHtml(formattedText);
  }
  scheduleGetSubscription() {
    // Call getSubscription immediately
    this.getSubscription();
    // Schedule to call getSubscription every 4 hours
    this.intervalId = setInterval(() => {
      this.getSubscription();
    }, 4 * 60 * 60 * 1000); // 4 hours in milliseconds
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
